import React, { useState, useEffect, useRef } from "react";
import { ThreeDots } from "react-loader-spinner";
import "../../Pages/Admin/Style.css";
import "./add_packages.css";
import Select from "react-select";
import "../../Api/apiUrls";
import { addAdminPackage } from "../../Api/apiUrls";
function Add_packages({ onClose }) {
  const [modalAdd_packagesIsOpen, setAdd_packagesModalIsOpen] = useState("");
  const [packageStatus, setPackageStatus] = useState("");
  const [packageName, setPackageName] = useState("");
  const [packagePrice, setPackagePrice] = useState("");
  const [packageDuration, setPackageDuration] = useState("");
  const [packageType, setPackageType] = useState("");
  const [packageDescription, setPackageDescription] = useState("");
  const [hsnCode, setHsnCode] = useState("");
  const [selectedPackage, setSelectedPackage] = useState([]);
  const [isAddingpackages, setIsAddingpackages] = useState(false);

  const duration = [
    { value: "Day", label: "Day" },
    { value: "Week", label: "Week" },
    { value: "Month", label: "Month" },
    { value: "Quarter", label: "Quarter" },
    { value: "Annual", label: "Annual" },
  ];
  const type = [
    { value: "Workshop", label: "Workshop" },
    { value: "Venue", label: "Venue" },
    { value: "News", label: "News" },
  ];
  const status = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  function reloadPage() {
    window.location.reload();
  }
  const closeAdd_packages = () => {
    setAdd_packagesModalIsOpen(false);
  };
  async function addPackage(
    packageName,
    packageDescription,
    packageDuration,
    packagePrice,
    hsnCode,
    packageType,
    packageStatus
  ) {
    try {
      const formData = new FormData();
      formData.append("name", packageName);
      formData.append("Details", packageDescription);
      formData.append("duration", packageDuration);
      formData.append("price", packagePrice);
      formData.append("type", packageType);
      formData.append("status", packageStatus);
      formData.append("hsn_code", hsnCode);

      // console.log(categoryHomepage);
      const response = await fetch(addAdminPackage, {
        method: "POST",
        body: formData,
      });
      const responseData = await response.json();
      if (response.ok) {
        if (responseData.status === 200){
          return true;
        }else{
          return false;
        }
      } else {
        throw new Error("Failed to add package");
      }
    } catch (error) {
      console.error("Error adding package:", error);
      return false; // Category addition failed
    }
  }

  const handleAddPackage = async () => {
    if (!packageName) {
      alert("Please fill in all fields");
      return;
    }

    setIsAddingpackages(true);

    const result = await addPackage(
      packageName,
      packageDescription,
      packageDuration,
      packagePrice,
      hsnCode,
      packageType,
      packageStatus
    );

    setIsAddingpackages(false);

    if (result) {
      alert("Package Added Successfully");
      setSelectedPackage("");
      console.log(packageName);
      setPackageName("");
      window.location.reload();
      // setIconFile(null);
      onClose(); // Close the modal
    } else {
      alert("Error Adding Package");
    }
  };
  const handleTypeChange = (selectedOption) => {
    setPackageType(selectedOption.value);
    console.log(selectedOption.value);
  };
  const handleDurationChange = (selectedOption) => {
    setPackageDuration(selectedOption.value);
    console.log(selectedOption.value);
  };
  const handleStatusChange = (selectedOption) => {
    setPackageStatus(selectedOption.value);
    console.log(selectedOption.value);
  };
  function reloadPage() {
    window.location.reload();
  }

  const handleClick = (e) => {
    if (e.currentTarget === e.target) {
      onClose();
      reloadPage();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [handleClick]);

  return (
    <div>
      {modalAdd_packagesIsOpen && <add_packages onClose={closeAdd_packages} />}
      <div className="popup-background">
        <div className="popup">
          <div
            class="modal-content"
            style={{
              width: "100%",
              height: "80%",
              padding: "2%",
              backgroundColor: "#fff",
              borderRadius: "5px",
            }}
          >
            <div
              class="modal-header"
              style={{
                width: "100%",
                marginBottom: "3%",
                borderBottom: "solid 1px #7e7a7a8c",
              }}
            >
              <h5
                class="modal-title"
                id="modalAddTitle"
                style={{ marginBottom: "2%" }}
              >
                <b>Add Packages</b>
              </h5>

              <button
                type="button"
                onClick={() => {
                  onClose();
                  reloadPage();
                }}
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div
              class="modal-body"
              style={{ overflowY: "scroll", padding: "2%" }}
            >
              <form>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Name
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    value={packageName}
                    onChange={(e) => setPackageName(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Description
                  </label>
                  <textarea
                    type="text"
                    id="selectedImg"
                    class="form-control"
                    value={packageDescription}
                    onChange={(e) => setPackageDescription(e.target.value)}
                  />
                </div>

                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Duration
                  </label>
                  <Select
                    onChange={handleDurationChange}
                    options={duration}
                  ></Select>
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Price
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    value={packagePrice}
                    onChange={(e) => setPackagePrice(e.target.value)}
                  />
                </div>


                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    HSN Code
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    value={hsnCode}
                    onChange={(e) => setHsnCode(e.target.value)}
                  />
                </div>

                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Category Type
                  </label>
                  <Select onChange={handleTypeChange} options={type}></Select>
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Category Status
                  </label>
                  <Select
                    onChange={handleStatusChange}
                    options={status}
                  ></Select>
                </div>
              </form>
            </div>

            <div
              class="modal-footer"
              style={{
                padding: "2%",
                marginTop: "3%",
                borderTop: "solid 1px #7e7a7a8c",
              }}
            >
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                onClick={() => {
                  onClose();
                  reloadPage();
                }}
              >
                Close
              </button>
              {isAddingpackages === true ? (
                <div>
                  <ThreeDots color="#000" height={50} width={50} />
                </div>
              ) : (
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary "
                  style={{ background: "#000 ", border: "none" }}
                  onClick={handleAddPackage}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Add_packages;
